const types =  {
    SET_INPUT_VALUE: 'SET_INPUT_VALUE',
    SET_INPUT_VALUE_PRACTICE_AREA: 'SET_INPUT_VALUE_PRACTICE_AREA',
    SET_PRACTICE_AREA_NEW: 'SET_PRACTICE_AREA_NEW',
    RESET_TIMEKEEPER_VALUES: 'RESET_TIMEKEEPER_VALUES',
    SET_TIMEKEEPER_DETAIL: "SET_TIMEKEEPER_DETAIL"
}

export default types;
